import { useCallback } from 'react';

import { useNavigate } from 'react-router';

import { queryClient } from '@queries';
import { globalStore, currentActivityAtom } from '@store';
import { Button } from '@ui';

import { LINKS } from '../../utils/routes';

export const NavigateToCurrentActivity = () => {
    const navigate = useNavigate();
    const navigateToActivities = useCallback(() => {
        globalStore.set(currentActivityAtom, null);
        queryClient.invalidateQueries();
        navigate(LINKS.getCurrentActivity());
    }, [navigate]);

    return <Button onClick={navigateToActivities}>Return to Current Activity</Button>;
};
